import { render, staticRenderFns } from "./GeneralLedgerBudgetAll.vue?vue&type=template&id=10d2c3f2&scoped=true&"
import script from "./GeneralLedgerBudgetAll.vue?vue&type=script&lang=js&"
export * from "./GeneralLedgerBudgetAll.vue?vue&type=script&lang=js&"
import style0 from "./GeneralLedgerBudgetAll.vue?vue&type=style&index=0&id=10d2c3f2&prod&lang=css&"
import style1 from "./GeneralLedgerBudgetAll.vue?vue&type=style&index=1&id=10d2c3f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d2c3f2",
  null
  
)

export default component.exports